import { functions } from './firebase';

export const cancelBooking = async (userId, slotRefPath) => {
    // console.log("database E", slotRefPath)
    try {
        await functions.httpsCallable('cancelBookingForUserId')({
            userId: userId,
            slotRefPath: slotRefPath,
        });
        return { success: true, message: "Avbokat" };
    } catch (error) {
        console.error("Could not cancel booking.", error.message)
        return { success: false, message: "Kunde inte avboka. " + error.message };
    }
}